<template>
  <div class="notification is-warning is-light action-confirm">
    <p>{{ message }}</p>
    <div class="buttons are-small mt-3">
      <button :class="['button', 'is-danger', { 'is-loading': loading }]" @click="$emit('confirm')">
        {{ label }}
      </button>
      <button class="button" :disabled="loading" @click="$emit('cancel')">Cancel</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActionConfirm",
  props: {
    message: { type: String, default: "" },
    label: { type: String, default: "Confirm" },
    loading: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.action-confirm { margin: 0.75rem 0 0; padding: 1rem; }
</style>
